module.exports = __webpack_public_path__ + "img/face33.daa0a7f1.gif";